import { html } from '@oskecare/fe-utilities/lib/LitElement/index.js';

export default function renderIePageTemplate() {
  return html`
    <div id="megamenu" class="mm-header">
      <div class="mm-top" data-hide-when-sticky="true">
        <div class="mm-container">
          <ul class="mm-nav">
            <li class="mm-nav__item">
              <a href="https://orange.sk" class="mm-link mm-link--white mm-top__link">
                ísť na Orange.sk
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div role="main">
      <div class="section">
        <div class="container">
          <div class="grid align-items-center">
            <div class="grid__col--md-6 grid__col--lg-5 grid__col--xl-4 mb-medium mb-md-none">
              <h2 class="h1">Nepodporovaný prehliadač</h2>
              <p class="mb-md-small">
                Pre fungovanie aplikácie Môj Orange odporúčame nainštalovať aktuálnu verziu
                prehliadačov Google Chrome alebo Mozilla Firefox.
              </p>
              <div class="buttons buttons--stack-on-xs">
                <a href="https://orange.sk" class="btn">Prejsť na Orange.sk</a>
              </div>
            </div>
            <div class="grid__col--1 grid__col--sm-3 grid__col--md-1 grid__col--lg-2"></div>
            <div class="grid__col--10 grid__col--sm-6 grid__col--md-5 grid__col--lg-4 align-center">
              <img
                class="img"
                src="assets/images/working-man-with-error-screen.svg"
                alt="Muž pracujúci pred obrazovkou s chybou"
                role="presentation"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="section bg-gray"></div>
    </div>
  `;
}
